module.exports = __webpack_public_path__ + "img/480.be680f48.jpg";